module.exports = __webpack_public_path__ + "static/media/ovimalli_1p.f0319deb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/door_models/ovimalli_1p.svg
// module id = 488
// module chunks = 0